import React, { Component } from 'react';
import { Nav, Header } from './layout';
import { Switch, Route, withRouter } from 'react-router-dom';
import { ParticipantsComponent, RegistrationSummaryComponent } from './participants';
import { ProgramsComponent } from './programs';
import { SettingsComponent } from './settings';
import { DashboardMessagesComponent, AddMessageComponent, EditMessageComponent, } from './dashboard-messages';
import { PermissionsComponent, DemographicsComponent } from './permissions';
import { HelpPageComponent } from './help';
import { IntakeFormsComponent, CreateIntakeFormComponent, EditIntakeFormComponent, PublishIntakeFormComponent, PreviewIntakeFormComponent } from './intake';
import { requireFeature, features } from './features';
import NotFound from './not-found';
import './App.scss';

class App extends Component {

  handleRouteChange(params) {
    const { location } = params;
    const { state } = location || {};
    const { focusElement } = state || {};
    const element = document.getElementById(focusElement ? focusElement : "view");
    element && element.focus();

    const intercomApplicationId = process.env.INTERCOM_APPLICATION_ID;
    const { Intercom } = window;
    const useIntercom = (intercomApplicationId && Intercom);
    if (useIntercom) {
      Intercom('update');
    }
    window.scrollTo(0, 0);
  }

  componentWillMount() {
    this.handleRouteChange(this.props);
  }

  componentDidUpdate(prevProps) {
    const { location : prevLocation } = prevProps;
    const { location : currentLocation } = this.props;
    if(currentLocation.pathname !== prevLocation.pathname) {
      this.handleRouteChange(this.props);
    }
  }

  render() {

    return (
      <div>
        <Header />
        <Nav />
        <div tabIndex="-1" id="view" className="no-focus">
          <Switch>
            <Route exact path="/admin-help" component={HelpPageComponent} />
            <Route exact path="/settings" component={SettingsComponent} />
            <Route exact path="/programs" component={ProgramsComponent} />
            <Route exact path="/permissions" component={PermissionsComponent}/>
            <Route exact path="/permissions/demographics" component={DemographicsComponent}/>
            <Route exact path="/add-message" component={AddMessageComponent}/>
            <Route exact path="/edit-message/:id" component={EditMessageComponent}/>
            <Route path="/dashboard-messages" component={DashboardMessagesComponent} />
            <Route exact path="/registration" component={RegistrationSummaryComponent} />
            <Route exact path="/intake-forms" component={requireFeature(IntakeFormsComponent, [features.intake])} />
            <Route path="/intake-forms/create/:siteId/:programId" component={requireFeature(CreateIntakeFormComponent, [features.intake])} />
            <Route path="/intake-forms/edit/:id" component={requireFeature(EditIntakeFormComponent, [features.intake])} />
            <Route path="/intake-forms/publish/:id" component={requireFeature(PublishIntakeFormComponent, [features.intake])} />
            <Route path="/intake-forms/preview/:id" component={requireFeature(PreviewIntakeFormComponent, [features.intake])} />
            <Route exact path="/unregistered" component={ParticipantsComponent}/>
            <Route exact path="/" component={ParticipantsComponent}/>
            <Route component={NotFound}/>
          </Switch>
        </div>
      </div>
    );
  }
}

App.propTypes = {
}

export default withRouter(App);
